import { ColumnDef } from "@tanstack/react-table";
import { Helmet } from "react-helmet-async";

import { type AuditLogRow, useAdminAudit } from "@/admin/services";

import { AdminDataTable } from "../../components/ui/data-table";
import { PageHeader } from "../_components/page-header";

export const AdminAuditPage = () => {
  const { data, isLoading } = useAdminAudit({ take: 100 });

  const columns: ColumnDef<AuditLogRow>[] = [
    {
      accessorKey: "createdAt",
      header: "When",
      cell: ({ row }) => (
        <span className="text-[12px] tabular-nums text-muted-foreground">
          {new Date(row.original.createdAt).toLocaleString()}
        </span>
      ),
    },
    {
      accessorKey: "action",
      header: "Action",
      cell: ({ row }) => (
        // Action codes are stable identifiers (`campaign.update`, `user.role`)
        // — render in mono so they read as code, not prose.
        <span className="mono inline-flex items-center rounded-sm bg-surface px-1.5 py-0.5 text-[11px] text-foreground">
          {row.original.action}
        </span>
      ),
    },
    {
      accessorKey: "actorEmail",
      header: "Actor",
      cell: ({ row }) => (
        <span className="text-[12px] text-muted-foreground">
          {row.original.actorEmail ?? row.original.actorId}
        </span>
      ),
    },
    {
      accessorKey: "target",
      header: "Target",
      cell: ({ row }) => (
        <span className="mono text-[11px] text-subtle">{row.original.target ?? "—"}</span>
      ),
    },
    {
      accessorKey: "meta",
      header: "Meta",
      cell: ({ row }) =>
        row.original.meta && Object.keys(row.original.meta).length > 0 ? (
          <pre className="mono max-w-md truncate text-[11px] text-muted-foreground">
            {JSON.stringify(row.original.meta)}
          </pre>
        ) : (
          <span className="text-subtle">—</span>
        ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Audit log · Admin</title>
      </Helmet>

      <PageHeader
        title="Audit log"
        description={`Append-only record of every admin write. ${data?.total ? `${data.total.toLocaleString()} events.` : ""}`}
        trail={["Admin"]}
      />

      <AdminDataTable columns={columns} data={data?.rows ?? []} loading={isLoading} pageSize={50} />
    </>
  );
};

export default AdminAuditPage;
